// Helpers puros del editor de programas. Extraidos del modal para que sean
// testeables sin necesidad de montar el componente React.

import { opcionesDeporte } from '../../lib/deportesOrg'

export const parseTags = (value) => {
  if (!value) return []
  if (Array.isArray(value)) return value.filter(Boolean)
  return value.split(',').map((t) => t.trim()).filter(Boolean)
}

// Normaliza un valor almacenado en programa.deportes (label vieja o slug nuevo)
// a su deporte_id (slug). Retorna el valor original si no hay match.
export const normalizarDeporte = (valor, orgDeportes) => {
  if (!valor) return null
  const opciones = opcionesDeporte(orgDeportes)
  const porId = opciones.find((o) => o.value === valor)
  if (porId) return porId.value
  const porNombre = opciones.find((o) => o.label.toLowerCase() === valor.toLowerCase())
  if (porNombre) return porNombre.value
  return valor
}

// Valida las secciones antes de guardar.
// Retorna null si todo OK, o el mensaje de error si algo no cumple.
export const validarSecciones = (secciones) => {
  if (!Array.isArray(secciones) || secciones.length === 0) return null
  for (let i = 0; i < secciones.length; i++) {
    const s = secciones[i]
    if (!s.nombre || s.nombre.trim().length < 3) {
      return `La seccion ${i + 1} necesita un nombre de al menos 3 caracteres`
    }
    if (!s.duracion_seg || s.duracion_seg < 30) {
      return `La seccion ${i + 1} necesita una duracion minima de 30 segundos`
    }
  }
  return null
}

// Valida y construye el payload del programa para enviar a saveProgramaCompleto.
// orgId DEBE venir del contexto de organizacion (useOrganization), NO del
// staff del usuario logueado, para que platform_admin pueda crear programas
// en la org que esta impersonando.
//
// Retorna { error } si hay validacion fallida, o { payload } si OK.
export const buildProgramaPayload = ({
  titulo,
  descripcion,
  deportes,
  habilidadIds,
  secciones,
  staffId,
  orgId
}) => {
  if (!orgId) {
    return {
      error: 'No pudimos identificar la organizacion. Refresca la pagina e intenta de nuevo.'
    }
  }
  if (!titulo || !titulo.trim()) {
    return { error: 'El titulo es obligatorio' }
  }
  const errSecciones = validarSecciones(secciones)
  if (errSecciones) return { error: errSecciones }

  return {
    payload: {
      titulo: titulo.trim(),
      descripcion: (descripcion || '').trim() || null,
      deportes: deportes || [],
      habilidadIds: habilidadIds || [],
      secciones: secciones || [],
      created_by: staffId || null,
      org_id: orgId
    }
  }
}

// Resuelve los habilidad_ids de una seccion a objetos {id, nombre} usando el
// catalogo de habilidades ya cargado. Conserva el orden e ignora ids que ya no
// existen en el catalogo (p. ej. habilidad borrada). Puro y testeable.
export const resolverHabilidadesSeccion = (habilidadIds = [], catalogo = []) => {
  if (!Array.isArray(habilidadIds) || habilidadIds.length === 0) return []
  const porId = new Map((catalogo || []).map((h) => [h.id, h]))
  return habilidadIds
    .map((id) => porId.get(id))
    .filter(Boolean)
    .map((h) => ({ id: h.id, nombre: h.nombre }))
}

// ¿Esta plantilla aplica al deporte que el usuario esta mirando?
//
// Una plantilla marcada "General" sirve, por definicion, para cualquier deporte: asi lo
// dice la propia ayuda del editor ("calentamiento, hidratacion, fisico, cierre: sirve para
// cualquier deporte"). Pero el filtro de la pantalla de Plantillas comparaba por igualdad
// exacta, asi que al elegir "Flag Football" DESAPARECIAN las Generales -- que tambien
// aplican a flag. El chip contradecia la definicion del valor.
//
// El modal de importar a un programa ya lo hacia bien; esto pone a las dos pantallas de
// acuerdo, que era la mitad del problema.
export const plantillaAplicaAlDeporte = (plantilla, deporteFiltro) => {
  if (!deporteFiltro || deporteFiltro === '__all') return true
  const suyo = plantilla?.deporte || 'todos'
  // "General" entra en cualquier deporte; el chip "General" sigue mostrando solo esas
  // porque ahi el filtro ES 'todos' y la igualdad basta.
  if (deporteFiltro === 'todos') return suyo === 'todos'
  return suyo === 'todos' || suyo === deporteFiltro
}
